import styled from 'styled-components';
import { CommonStyledComponentProps } from '__utils/type';
import { useMediaQuery } from 'react-responsive';
import React, { useState, useEffect } from 'react';
import LargePopup from 'components/popup/large-popup';
import LAMFIcon from '../../images/lamf-redeem-icon.svg';

const LAMFContainer = styled.div<CommonStyledComponentProps>`
    *,p{
        font-size: ${(props: CommonStyledComponentProps) => props.isMobile ? '14px' : '16px'};
        line-height: 1.5;
    }
    *, *::before, *::after {
        box-sizing: border-box;
    }


    .lamf-card {
        display: flex;
        width : ${(props: CommonStyledComponentProps) => props.isMobile ? '328px' : ''};
        border-radius: 8px;
        overflow: hidden;
        max-width: ${(props: CommonStyledComponentProps) => props.isMobile ? '' : '100%;'}; 
        flex-direction: ${(props: CommonStyledComponentProps) => props.isMobile ? 'column' : ''}; 
        align-items: ${(props: CommonStyledComponentProps) => props.isMobile ? 'flex-start' : ''};  
    }

    .card-left {
        display: flex;
        padding: ${(props: CommonStyledComponentProps) => props.isMobile ? '16px' : '24px'};
        width: ${(props: CommonStyledComponentProps) => props.isMobile ? '' : '392px'};
        flex-direction: column;
        align-items: flex-start;
        justify-content: ${(props: CommonStyledComponentProps) => props.isMobile ? 'center' : ''};
        gap: ${(props: CommonStyledComponentProps) => props.isMobile ? 'var(--spacing-sp-8, 8px)' : 'var(--spacing-sp-24, 24px)'};
        align-self: stretch;
        border-radius: ${(props: CommonStyledComponentProps) => props.isMobile ? 'var(--radius-lg, 12px) var(--radius-lg, 12px) var(--radius-none, 0px) var(--radius-none, 0px)' 
        : 'var(--radius-xl, 16px) 0px 0px var(--radius-xl, 16px)'}; 
        background: var(--color-netural-000, #FFF);
        flex: ${(props: CommonStyledComponentProps) => props.isMobile ? '' : '1'}; 
        flex-basis: ${(props: CommonStyledComponentProps) => props.isMobile ? '' : '0'}; 
    }

    .card-right {
        display: flex;
        padding: ${(props: CommonStyledComponentProps) => props.isMobile ? '8px 16px 16px 16px' : '24px'};
        width: ${(props: CommonStyledComponentProps) => props.isMobile ? '' : '427px'};
        flex-direction: column;
        align-items: ${(props: CommonStyledComponentProps) => props.isMobile ? 'flex-start' : 'flex-end'}; 
        gap: ${(props: CommonStyledComponentProps) => props.isMobile ? 'var(--spacing-sp-16, 16px)' : 'var(--spacing-sp-24, 24px)'}
        border-radius: ${(props: CommonStyledComponentProps) => props.isMobile ? 'var(--radius-none, 0px) var(--radius-none, 0px) var(--radius-lg, 12px) var(--radius-lg, 12px)' 
        : '0px var(--radius-xl, 16px) var(--radius-xl, 16px) 0px'}; 
        background: ${(props: CommonStyledComponentProps) => props.isMobile ? 'linear-gradient(180deg, #F8F8FA -1.81%, #CEDFF4 120.23%)' 
        : 'radial-gradient(298.01% 227.3% at -43.91% 19.5%, #F8F8FA 28.78%, #CEDFF4 100%)'};  
        flex: ${(props: CommonStyledComponentProps) => props.isMobile ? '' : '1'}; 
        flex-basis: ${(props: CommonStyledComponentProps) => props.isMobile ? '' : '0'}; 
        align-self: ${(props: CommonStyledComponentProps) => props.isMobile ? 'stretch' : ''};
    }
    
    .lamf-icon {
        width:${(props: CommonStyledComponentProps) => props.isMobile ? '72px' : '160px'}; 
        height:${(props: CommonStyledComponentProps) => props.isMobile ? '70px' : '156px'};
    }

    .para1, .para2 {
        display: contents;
    }
    
    .para1{
        color: var(--color-secondary-b-450, #0AADE1);

        /* Roboto/Heading/head-small-500 */
        font-family: var(--app-style-heading, Roboto);
        font-size: ${(props: CommonStyledComponentProps) => props.isMobile ? 'var(--app-size-fs-3xl, 18px)' : 'var(--app-size-fs-3xl, 24px)'}; 
        font-style: normal;
        font-weight: 500;
        line-height:${(props: CommonStyledComponentProps) => props.isMobile ? 'var(--app-line-height-lh-xl, 28px)' : 'var(--app-line-height-lh-xl, 32px)'}; 
    }

    .para2 {
        color: var(--color-netural-500, #444845);
        /* Roboto/Heading/head-small-500 */
        font-family: var(--app-style-heading, Roboto);
        font-size: ${(props: CommonStyledComponentProps) => props.isMobile ? 'var(--app-size-fs-3xl, 18px)' : 'var(--app-size-fs-3xl, 24px)'}; 
        font-style: normal;
        font-weight: 500;
        line-height: ${(props: CommonStyledComponentProps) => props.isMobile ? 'var(--app-line-height-lh-xl, 28px)' : 'var(--app-line-height-lh-xl, 32px)'}; 
    }
    
    .para3{
        color: var(--color-netural-500, #444845);

        /* Roboto/Micro/mic-large-400 */
        font-family: var(--app-style-micro, Roboto);
        font-size: var(--app-size-fs-md, 14px);
        font-style: normal;
        font-weight: 400;
        line-height: var(--app-line-height-lh-sm, 20px); /* 142.857% */
        letter-spacing: 0.034px;
    }

    .para3 span {
        font-weight: 700;
        font-size : 14px;
    }
    
    .card-right ul, {
        list-style: none;
        padding: 0;
    }
    
    .card-right ul li {
        display: flex;
        align-items: center;
        font-size: 14px;
        padding: 8px 0;
    }

    .card-right ul li::before {
        content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8.5L6.33333 12L13 5" stroke="%230A4EE1" stroke-width="1.6" stroke-linecap="round"/></svg>');
        margin-right: 10px; /* Space between the icon and text */
        margin-top: 3px;
    }
    
    .actions {
        margin-top: ${(props: CommonStyledComponentProps) => props.isMobile ? '' : '10px'}; 
        display: ${(props: CommonStyledComponentProps) => props.isMobile ? '' : 'flex'}; 
        justify-content: ${(props: CommonStyledComponentProps) => props.isMobile ? '' : 'space-between'}; 
        width: ${(props: CommonStyledComponentProps) => props.isMobile ? '' : '100%'};
    }

    .btn-primary {
        display: flex;
        padding: ${(props: CommonStyledComponentProps) => props.isMobile ? '10px var(--spacing-sp-48, 48px)' : '10px 20px'};
        justify-content: center;
        align-items: center;
        gap: ${(props: CommonStyledComponentProps) => props.isMobile ? 'var(--spacing-sp-8, 8px)' : ''};
        align-self: ${(props: CommonStyledComponentProps) => props.isMobile ? 'stretch' : ''};
        border-radius: 8px;
        font-size: ${(props: CommonStyledComponentProps) => props.isMobile ? '' : '14px'};
        cursor: pointer;
        //box-sizing: border-box;
        background: var(--color-netural-600, #191C1B);
        border: 1px solid var(--color-netural-600, #191C1B);
        color: white;
        width: ${(props: CommonStyledComponentProps) => props.isMobile ? '140%' : '190px'};
        margin-bottom: ${(props: CommonStyledComponentProps) => props.isMobile ? '10px' : ''};
        margin-top: ${(props: CommonStyledComponentProps) => props.isMobile ? '20px' : '10px'};
    }

    .btn-secondary {
        display: flex;
        padding: ${(props: CommonStyledComponentProps) => props.isMobile ? '10px var(--spacing-sp-48, 48px)' : '10px 20px'};
        justify-content: center;
        align-items: center;
        gap: ${(props: CommonStyledComponentProps) => props.isMobile ? '10px' : ''};
        align-self: ${(props: CommonStyledComponentProps) => props.isMobile ? 'stretch' : ''};
        border-radius: 8px;
        font-size: ${(props: CommonStyledComponentProps) => props.isMobile ? '' : '14px'};
        cursor: pointer;
        //box-sizing: border-box;
        background: var(--color-netural-000, #FFF);
        border: 1px solid var(--color-netural-600, #191C1B);
        color: #191C1B;
        width: ${(props: CommonStyledComponentProps) => props.isMobile ? '140%' : '160px'};
        font-weight: 500;
        margin-top: ${(props: CommonStyledComponentProps) => props.isMobile ? '' : '10px'};
    }

    
    hr.custom-line {
        display: ${(props: CommonStyledComponentProps) => props.isMobile ? 'block' : 'none'};
        width: 296px;
        height: 1px;
        background: var(--color-secondary-b-400, #E9F1FF);
        margin-bottom: 1px;
      }

`
interface LAMFProps {
    onClose: () => void;
    openRedeemPopup: (record: any) => void;
    registerLAMFDP : () => void;
    portfolioRecord: any;
}


const LAMFPopup: React.FC<LAMFProps> = ({ onClose,openRedeemPopup,portfolioRecord,registerLAMFDP }) => {

    const isMobile = useMediaQuery({ maxWidth: 767 });
    const [showSuccessPopup, setShowSuccessPopup] = useState<any>({ show: false });

    const onClosePopup = () => {
        setShowSuccessPopup({ show: false });
        onClose();
    }

    return (
        <div>
            <LargePopup
                closable={isMobile || !showSuccessPopup.show}
                modalWidth={'fit-content'}
                onClose={onClosePopup}
                style={{background: 'transparent'}}
                isLAMFRedeemPopup = {true}
            >
                <LAMFContainer isMobile={isMobile}>
                    <div className="lamf-card">
                        <div className="card-left">
                            <img className="lamf-icon" src={LAMFIcon} alt="Illustration"/>
                            <p className='para1'>Protect trail commissions from MFs. </p>
                            <p className='para2'>Choose Loan Against Mutual Funds</p>
                            <hr className="custom-line"/>
                            <p className = "para3">Earn an <span>extra 0.5%</span> on loan amounts over ₹5L</p>
                        </div>
                        <div className="card-right">
                            <ul>
                                <li>Zero Foreclosure Charges</li>
                                <li>Quick Access to Funds : Disbursed within 2 hours</li>
                                <li>Flexible Terms : 3-year OD</li>
                                <li>Competitive Interest Rate : 10.5%</li>
                                <li>Easy Application : Just 10 minutes</li>
                                <li>Generous Loan Amount : Up to 45% of equity holdings; 80% of debt holdings</li>
                            </ul>
                            { isMobile ?
                            (<div className="actions">
                                <button className="btn btn-primary" onClick={registerLAMFDP}>Yes, I'm Interested</button>
                                <button className="btn btn-secondary" onClick={() => openRedeemPopup(portfolioRecord)}>No, Redeem Fund</button>
                            </div>) : (<div className="actions">
                                <button className="btn btn-secondary" onClick={() => openRedeemPopup(portfolioRecord)}>No, Redeem Fund</button>
                                <button className="btn btn-primary" onClick={registerLAMFDP}>Yes, I'm Interested</button>
                            </div>) }
                        </div>
                    </div>
                </LAMFContainer>
            </LargePopup>
        </div>   
    );
}

export default LAMFPopup
